import { useEffect } from 'react';
const useOnValueSetCb = ({ onChange, isNavigated, hasEnteredValueChanged, enteredValue }) => useEffect(() => {
    onChange && !isNavigated && hasEnteredValueChanged && onChange(enteredValue);
}, [enteredValue, isNavigated, onChange, hasEnteredValueChanged]);
export default useOnValueSetCb;
//# sourceMappingURL=useOnValueSetCb.js.map